import { apiClient } from "../client-api";
import { authHeader } from "@/_helpers";
import merge from "lodash/merge";
import appConfig from "@/app.config";

const basePath = appConfig.apiPath + "checkout/";

export default {
  async get(orderID = 0, conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.get(
        basePath + "paypal/orders/" + orderID + "/",
        conf
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
  async capture(orderID, data = null, conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.post(
        basePath + "paypal/orders/" + orderID + "/capture/",
        data,
        conf
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  },
  async with_paypal__createOrder__forPlan(data = null, conf = {}) {
    conf = merge({}, { headers: authHeader() }, conf);
    try {
      const response = await apiClient.post(
        basePath + "paypal/orders/create/plan/",
        data,
        conf
      );
      return Promise.resolve(response.data);
    } catch (error) {
      return Promise.reject(error.response.data.message);
    }
  }
};
